import { Card, Typography, Box, useTheme } from '@mui/material';
import Iconify from 'components/Iconify'; // If you use iconify, else replace with your favorite icon method

/**
 * SummaryCard
 * @param {Object} props 
 * @param {string} props.title - Label/title (e.g. "Sent", "Workers")
 * @param {string|number} props.value - Value to display
 * @param {string} [props.icon] - Iconify icon string (e.g. "mdi:worker"), or pass a React element as icon
 * @param {string} [props.color] - Main indicator color (optional)
 */
export default function SummaryCard({ title, value, icon, color }) {
  const theme = useTheme();

  return (
    <Card
      sx={{
        p: 2.5,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        boxShadow: theme.shadows[2],
        bgcolor: color ? `${color  }16` : theme.palette.background.paper, // transparent color if provided
        borderRadius: 2,
        minHeight: 105,
        justifyContent: 'center'
      }}
    >
      {icon && (
        <Box
          sx={{
            mb: 1,
            color: color || theme.palette.grey[800],
            fontSize: 32,
            height: 36,
            width: 36,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          {typeof icon === "string"
            ? <Iconify icon={icon} width={32} height={32} />
            : icon}
        </Box>
      )}
      <Typography variant="h5" color={color || "textPrimary"}>
        {value}
      </Typography>
      <Typography variant="caption" color="text.secondary" align="center" sx={{mt: 0.2}}>
        {title}
      </Typography>
    </Card>
  );
}
